import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { FIELD_TYPES, INPUT } from "./constants/FieldValueConstants";
import Vuetify from "vuetify";
import { KeyValue } from "@/shared/models/KeyValue";
import { PreventKey } from "@/shared/mixins/mixins";

Vue.use(Vuetify);
@Component({
  name: "FieldValue"
})
export default class FieldValue extends PreventKey {
  @Prop({ default: "" }) fieldType!: string;
  @Prop({ default: "" }) label!: string;
  @Prop() selectElements!: KeyValue[];
  @Prop({ required: true, default: "" }) value!: string | boolean | number;

  FIELD_TYPES = FIELD_TYPES;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  localValue: string | boolean | number = this.value;

  created() {
    this.localValue = this.value;
  }

  @Watch("value")
  valueWatcher(newValue: string | boolean | number) {
    this.localValue = newValue;
  }

  @Watch("localValue")
  localValueWatcher(newValue: string | boolean | number) {
    this.$emit(INPUT, newValue);
  }
}
